import React from 'react'

const AiMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="none" stroke="currentColor" strokeWidth="1.5">
    <g opacity="0.35">
      <line x1="40" y1="40" x2="180" y2="50" />
      <line x1="40" y1="40" x2="180" y2="120" />
      <line x1="40" y1="40" x2="180" y2="190" />
      <line x1="40" y1="120" x2="180" y2="50" />
      <line x1="40" y1="120" x2="180" y2="120" />
      <line x1="40" y1="120" x2="180" y2="190" />
      <line x1="40" y1="200" x2="180" y2="50" />
      <line x1="40" y1="200" x2="180" y2="120" />
      <line x1="40" y1="200" x2="180" y2="190" />
      <line x1="180" y1="50" x2="280" y2="120" />
      <line x1="180" y1="120" x2="280" y2="120" />
      <line x1="180" y1="190" x2="280" y2="120" />
    </g>
    <g fill="currentColor" stroke="none">
      <circle cx="40" cy="40" r="5" />
      <circle cx="40" cy="120" r="5" />
      <circle cx="40" cy="200" r="5" />
      <circle cx="180" cy="50" r="6" />
      <circle cx="180" cy="120" r="6" />
      <circle cx="180" cy="190" r="6" />
      <circle cx="280" cy="120" r="12" />
    </g>
  </svg>
)

const DesignMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="currentColor">
    <rect x="40" y="40" width="160" height="160" rx="22" opacity="0.32" />
    <rect x="100" y="80" width="160" height="160" rx="22" opacity="0.55" />
    <rect x="80" y="20" width="80" height="80" rx="14" />
    <circle cx="220" cy="60" r="14" opacity="0.85" />
  </svg>
)

const CommsMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="currentColor">
    <g opacity="0.32">
      <rect x="40" y="36" width="180" height="100" rx="20" />
      <path d="M70 136 L70 168 L102 136 Z" />
    </g>
    <g opacity="0.6">
      <rect x="100" y="96" width="180" height="100" rx="20" />
      <path d="M252 196 L264 226 L222 196 Z" />
    </g>
    <g>
      <rect x="60" y="60" width="110" height="62" rx="14" />
      <path d="M76 122 L76 148 L102 122 Z" />
    </g>
  </svg>
)

const DevMotif: React.FC = () => (
  <svg
    viewBox="0 0 320 240"
    fill="none"
    stroke="currentColor"
    strokeWidth="6"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M100 60 L40 120 L100 180" />
    <path d="M220 60 L280 120 L220 180" />
    <line x1="180" y1="50" x2="140" y2="190" strokeOpacity="0.5" strokeWidth="5" />
  </svg>
)

const CloudMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="none" stroke="currentColor" strokeWidth="2">
    <path
      d="M70 168 Q40 168 40 136 Q40 104 70 104 Q70 72 110 72 Q140 40 180 70 Q230 60 240 104 Q280 104 280 144 Q280 174 250 174 L70 174 Z"
      fill="currentColor"
      fillOpacity="0.16"
    />
    <g fill="currentColor" stroke="none">
      <circle cx="90" cy="130" r="3" />
      <circle cx="130" cy="125" r="3" />
      <circle cx="170" cy="130" r="3" />
      <circle cx="210" cy="125" r="3" />
      <circle cx="244" cy="135" r="3" />
      <circle cx="110" cy="150" r="3" />
      <circle cx="150" cy="146" r="3" />
      <circle cx="190" cy="150" r="3" />
      <circle cx="230" cy="155" r="3" />
    </g>
  </svg>
)

const MarketingMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
    <path d="M40 124 L130 84 L130 164 Z" fill="currentColor" fillOpacity="0.45" strokeWidth="0" />
    <rect x="130" y="96" width="40" height="56" fill="currentColor" strokeWidth="0" />
    <path d="M195 84 Q220 124 195 164" />
    <path d="M225 64 Q260 124 225 184" strokeOpacity="0.55" />
    <path d="M255 44 Q298 124 255 204" strokeOpacity="0.3" />
  </svg>
)

const CrmMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="none" stroke="currentColor" strokeWidth="1.5">
    <g strokeOpacity="0.45">
      <line x1="60" y1="50" x2="160" y2="120" />
      <line x1="60" y1="50" x2="220" y2="70" />
      <line x1="60" y1="50" x2="120" y2="190" />
      <line x1="120" y1="190" x2="160" y2="120" />
      <line x1="160" y1="120" x2="220" y2="70" />
      <line x1="160" y1="120" x2="280" y2="120" />
      <line x1="160" y1="120" x2="220" y2="200" />
      <line x1="220" y1="70" x2="280" y2="120" />
      <line x1="220" y1="200" x2="280" y2="120" />
    </g>
    <g fill="currentColor" stroke="none">
      <circle cx="60" cy="50" r="9" />
      <circle cx="160" cy="120" r="13" />
      <circle cx="120" cy="190" r="8" />
      <circle cx="220" cy="70" r="9" />
      <circle cx="280" cy="120" r="10" />
      <circle cx="220" cy="200" r="8" />
    </g>
  </svg>
)

const AiDevMotif: React.FC = () => (
  <svg viewBox="0 0 320 240" fill="none">
    <g stroke="currentColor" strokeWidth="4" strokeOpacity="0.45" strokeLinecap="round" strokeLinejoin="round">
      <path d="M70 60 L40 120 L70 180" />
      <path d="M250 60 L280 120 L250 180" />
    </g>
    <path d="M180 20 L120 130 L160 130 L140 220 L210 100 L170 100 L200 20 Z" fill="currentColor" />
  </svg>
)

export const MOTIFS: Record<string, React.FC> = {
  ai: AiMotif,
  design: DesignMotif,
  comms: CommsMotif,
  dev: DevMotif,
  cloud: CloudMotif,
  marketing: MarketingMotif,
  crm: CrmMotif,
  'ai-dev': AiDevMotif,
}
